module.exports = __webpack_public_path__ + "static/media/thimble.cbc7f340.webp";